import {
  PRINT_PDF_OWN,
  PRINT_PDF_PEER,
  PRINT_PDF_OWN_TA,
  PRINT_PDF_EVU_ADMIN,
  PRINT_PDF_REPORT,
  PRINT_PDF_REPORT_TA
} from "./constants";

const initialState = {
  // chart: <div></div>,
  // gap: <div></div>,
  // peer1Name: "",
  // peer2Name: "",
  // peer3Name: "",
  // setHighLight,
  // id, peer2, chart, gap, language
  // , drivers
  // chart,
  // highlight,
  // setHighLight,
  // progressBar,
  // language,
  // mapResults,
  // categories,
  // qdata,
  // item,
  // index
};

export default function evaluation(state = initialState, action) {
  switch (action.type) {
    case PRINT_PDF_OWN:
      return {};

    case PRINT_PDF_OWN_TA:
      return {};

    case PRINT_PDF_PEER:
      return {};

    case PRINT_PDF_EVU_ADMIN:
      return {};

    case PRINT_PDF_REPORT:
      return {};

    case PRINT_PDF_REPORT_TA:
      return {};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/pdf/reducer.js